import { UsersError } from '@/lib/Errors';
import _axios from '@/plugins/axios';
export default {
	async getHospitals () {
		const response = await _axios.get('hospital');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getHospitalById (id) {
		const response = await _axios.get(`/hospital/${id}`);
		if (response.data.resFlag) {
			const userJson = response.data.data;
			return userJson;
		} else {
			throw new UsersError('Invalid id');
		}
	},
	async createHospital (body) {
		const response = await _axios.post('hospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async editHospital (body) {
		const response = await _axios.put(`hospital/${body.id}`, body);
		if (response.data.resFlag) {
			const userJson = response.data;
			return userJson;
		} else {
			throw new UsersError('Invalid id');
		}
	},
	async deleteHospital (id) {
		const response = await _axios.delete(`hospital/${id}`);
		if (response.data.resFlag) {
			// const userJson = response.data.data;
			const userJson = response;
			return userJson;
		} else {
			throw new UsersError('Invalid id');
		}
	},
	async getHospitalAdmins () {
		var response = [];
		await _axios
			.get('/user/gethospitaladmins')
			.then((res) => {
				response = res.data;
			})
			.catch((err) => {
				if (err.response) {
					response = err.response; // => the response payload
				}
			});
		return response.data;
	},
	async assignUserToHospital (body) {
		const response = await _axios.post('hospital/assignusertohospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async deassignUserFromHospital (body) {
		const response = await _axios.post('hospital/deassignuserfromhospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async assignAdminToHospital (body) {
		const response = await _axios.post('hospital/assignadmintohospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async deassignAdminToHospital (body) {
		const response = await _axios.post('hospital/deassignadminfromhospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async assignPatientToHospital (body) {
		const response = await _axios.post('hospital/assignpatienttohospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async assignDoctorToHospital (body) {
		const response = await _axios.post('hospital/assigndoctortohospital', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getRelatedMedicalStaffForHospital (hospitalId) {
		const response = await _axios.get('hospital/getrelatedmedicalstaffforhospitalV2', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async supportmessage () {
		const response = await _axios.get('supportmessage/getdistinctgroups');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('No meta data!');
	},
	async sendSupportMessage (body) {
		const response = await _axios.post('supportmessage', body);
		if (response.status === 201) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async changeSupportMessageStatus (body) {
		const response = await _axios.post('supportmessage/setstatus', body);
		if (response.status === 201) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async sendFileSupportMessage (body) {
		const response = await _axios.post('/supportmessage/addfile', body.FormDataSend, {
			headers: { RelatedToSupportMessageId: body.RelatedToSupportMessageId, 'Content-Type': 'multipart/form-data' },
		});
		if (response.status === 200) {
			return response.data;
		} else {
			throw new UsersError('Could not upload image!');
		}
	},

	async roomDetails (id) {
		const response = await _axios.get('supportmessage/getmessagesbygroupid', { headers: { SupportMessageId: id } });
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('No meta data!');
	},

	async getRelatedPatients (hospitalId) {
		const response = await _axios.get('hospital/getrelatedpatientsforhospitalv2', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getRelatedMedicalStaff (hospitalId) {
		const response = await _axios.get('hospital/getrelatedmedicalstaffforhospital', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getMedicalStaffAbleToDoBillingForOrg () {
		const response = await _axios.get('hospital/getmedicalstaffabletodobillingfororg');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},

	async getRelatedPatientsv2 (hospitalId) {
		const response = await _axios.get('hospital/getrelatedpatientsforhospitalv2', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getRelatedPatientsV4 (hospitalId) {
		const response = await _axios.get('hospital/getrelatedpatientsforhospitalv4', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async getRelatedMedicalStaffForHospitalV3 (hospitalId) {
		const response = await _axios.get('hospital/getrelatedmedicalstaffforhospitalV3', {
			headers: { hospitalId: hospitalId },
		});
		if (response.data.resFlag) {
			return response.data?.data;
		}
		throw new UsersError('No meta data!');
	},
	async assignMultipleUsersToHospital (body) {
		const response = await _axios.post('hospital/assignmultipleuserstohospital', body);
		if (response.data.resFlag) {
			return response.data?.data;
		}
		throw new UsersError('No meta data!');
	},
	async deassigMedicalStaffFromHospitalv2 (body) {
		const response = await _axios.delete('hospital/deassigmedicalstafffromhospitalv2', {
			data: body,
		});
		if (response.data.resFlag) {
			return response.data?.data;
		}
		throw new UsersError('Error while deassigning medical staff!');
	},
	async deassignMultipleMedicalStaffFromHospitalv2 (body) {
		const response = await _axios.delete('hospital/deassigmultiplemedicalstafffromhospitalv2', {
			data: body,
		});
		if (response.data.resFlag) {
			return response.data?.data;
		}
		throw new UsersError('Error while deassigning medical staff!');
	},
	async getEcpMappingLocation (hospitalId) {
		const response = await _axios.get('ecp/getecpmappinglocation', { headers: { hospitalId: hospitalId } });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async doAutomaticEcpUsersMapping (body) {
		const response = await _axios.put('ecp/doautomaticecpusersmapping', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async doAutomaticEcpResidentsMapping (body) {
		const response = await _axios.put('ecp/doautomaticecpresidentsmapping', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async doFinalizeMeasurmentsAutomatically (body) {
		const response = await _axios.put('ecp/dofinalizemeasurmentsautomatically', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('No meta data!');
	},
	async setRPMStatus (body) {
		try {
			const res = await _axios.put(
				'/user/setRPMStatus',
				{},
				{
					headers: body,
				},
			);
			return res.data;
		} catch (err) {
			if (err.response) {
				return err.response.data;
			} else {
				throw err;
			}
		}
	},
	async setRTMStatus (body) {
		try {
			const res = await _axios.put(
				'/user/setRTMStatus',
				{},
				{
					headers: body,
				},
			);
			return res.data;
		} catch (err) {
			if (err.response) {
				return err.response.data;
			} else {
				throw err;
			}
		}
	},
	async setCCMStatus (body) {
		try {
			const res = await _axios.put(
				'/user/setCCMmStatus',
				{},
				{
					headers: body,
				},
			);
			return res.data;
		} catch (err) {
			if (err.response) {
				return err.response.data;
			} else {
				throw err;
			}
		}
	},
};
